import React from 'react';
import useStore from '../../store/useStore';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBookmark,
  //faCalendar,
  //faClock,
  //faClone,
  //faCompass,
  faEnvelope
  //faFile,
  //faFloppyDisk,
  //faHandshake,
  //faListAlt
} from '@fortawesome/free-regular-svg-icons';
import {
  faCalendarPlus,
  faNoteSticky
  //faPeopleGroup,
  //faPeopleRoof
} from '@fortawesome/free-solid-svg-icons';

// @ts-ignore
import { CalendarHeatMap, Location, Group } from '@carbon/icons-react';

const StatementCardEvents = ({ data, datasource }: { data: any; datasource: any }) => {
  const {
    setParams

    //view /*filters, view, settings*/
  } = useStore((state: any) => ({
    setParams: state.setParams
  }));

  function isValidHttpUrl(string: string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  function openLink(
    eventURL: string,
    eventId: string,
    eventName: string,
    eventDateStartEnd: string,
    eventGroup: string,
    eventSector: string,
    eventPlace: string
  ) {
    if (eventId !== '' && eventId !== undefined) {
      //in other cases try to load sessions of event
      setParams('type', 'sessions'); //navigate to sessions
      setParams('eventid', eventId); // set event id
      setParams('eventName', eventName);
      setParams('eventDateStartEnd', eventDateStartEnd);
      setParams('eventGroup', eventGroup);
      setParams('eventSector', eventSector);
      setParams('eventPlace', eventPlace);
      setParams('darkTheme', '0'); //remove dark theme
    } else if (isValidHttpUrl(eventURL)) {
      //in case of link, open it in a new window
      window.open(eventURL);
    }
  }

  //console.log(data)
  //let urlAgenda:string=data.DocumentNumber;
  return (
    <div
      data-span="4"
      className="statementcard ituCard"
      onClick={() =>
        openLink(
          data.EventURL,
          data.EventId,
          data.Title,
          data.DateEventStartEnd,
          data.Group,
          data.SectorGroup,
          data.Place
        )
      }
      style={{ cursor: 'pointer' }}>
      <div className="statementcontent">
        <p className="statementtype">{data.Type}</p>
        <p className="statementadminorg">{data.Title}</p>

        <p style={{ marginTop: '20px', color: '#6e6e6e', fontSize: '1rem' }}>
          <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
            <CalendarHeatMap />
          </span>
          {/* adding space */}
          {'\u00A0'}
          {'\u00A0'}
          {data.DateEventStartEnd}
        </p>

        {data.Place !== '' ? (
          <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
            <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              <Location />
            </span>
            {/* adding space */}
            {'\u00A0'}
            {'\u00A0'}
            {data.Place}
          </p>
        ) : null}

        {data.Group !== '' ? (
          <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
            <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              <Group />
            </span>
            {/* adding space */}
            {'\u00A0'}
            {'\u00A0'}
            {data.SectorGroup}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default StatementCardEvents;
